<div #chatComponent class="chatComponent">
  <div class="chatComponent__userList" *ngIf="!activeGroup && !newConv">
    <vng-chat-group-list (activeGroupChanged)="activateGroup($event)"></vng-chat-group-list>
  </div>

  <div class="">
    <div class="chatComponent__chatPane">
      <ng-container *ngIf="activeGroup || newConv">
        <!-- <img [src]="activeGroup.groupImageUrl" width="40" height="40" class="rounded-circle ml-2"> -->
        <div class="chatComponent__chatOptions" *ngIf="!newConv">
          {{ activeGroup.groupName }}
        </div>

        <div class="chatComponent__chatMessages" #chatmessages >
          <vng-chat-group-messages [changesHelper]="changesHelper" [currentConversation]="activeGroup" *ngIf="!newConv"></vng-chat-group-messages>
        </div>
        <div class="chatComponent__chatMessageSend">
          <vng-chat-textinput-bar [isNotFirstMessage]="true" [currentConversation]="activeGroup" (reloadMessages)="reloadMessages($event)" *ngIf="!newConv"></vng-chat-textinput-bar>
          <vng-chat-textinput-bar 
           [nickVisible]="true"
           [acceptTermsEnable]="acceptTermsEnable"
           [newConversationAdvId]="newConversationAdvId" 
           [currentConversation]="newConversationAdvId" 
           (submitInitialMessage)="fireInitialConversationMessage($event)" 
           *ngIf="newConv">
          </vng-chat-textinput-bar>
        </div>
      </ng-container>
    </div>
  </div>
</div>


